module.exports = __webpack_public_path__ + "img/enterprise.6fddce46.png";